import { Component, OnInit } from "@angular/core";
import { BpMenuSistemaModel } from "src/app/core/model/menu/bp-menu-sistema-model";
import { AppService } from "src/app/services/app.service";
import { EventEmitterBaseService } from "src/app/core/services/event-emitter-service/event-emitter.service";
import { SessionService } from "../../core/services/session/session.service";
import { AppEvents } from "../../core/types/app-events";
import { construirMenu } from "src/app/share/tools/menu-tools";
import { SistemaEnum } from "src/app/core/enum/sistema-enum";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  public menu: BpMenuSistemaModel[] = [];
  constructor(public appService: AppService, public session: SessionService) {
    EventEmitterBaseService.get(AppEvents.buildSidebarNavidationMenu).subscribe(
      () => (this.menu = construirMenu(this.session, SistemaEnum.Bilhetagem, "Bilhetagem"))
    );
  }

  public ngOnInit(): void {
    this.session.buildUserSessionFromLocalStorage();
    this.menu = construirMenu(this.session, SistemaEnum.Bilhetagem, "Bilhetagem");
  }
}
